
import { Mail, MessageCircle, MessageSquare } from "lucide-react";
import React from "react";

export const channelLabels = {
  email: "Email",
  whatsapp: "WhatsApp",
  sms: "SMS"
};

// Get color for chart bars based on channel
export const getBarColor = (channel: string) => {
  switch (channel) {
    case 'email':
      return {
        fill: "url(#emailBarGradient)",
        stroke: "#58aba8"
      };
    case 'whatsapp':
      return {
        fill: "url(#whatsappBarGradient)",
        stroke: "#25D366"
      };
    case 'sms':
      return {
        fill: "url(#smsBarGradient)",
        stroke: "#FF6B6B"
      };
    default:
      return {
        fill: "#e5e7eb",
        stroke: "#9ca3af"
      };
  }
};

// Get appropriate icon for each channel
export const getChannelIcon = (channel: string) => {
  switch (channel) {
    case 'email':
      return <Mail className="h-4 w-4 text-blue-600" />;
    case 'whatsapp':
      return <MessageCircle className="h-4 w-4 text-green-600" />;
    case 'sms':
      return <MessageSquare className="h-4 w-4 text-purple-600" />;
    default:
      return null;
  }
};
